import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './flowambassador2.css'

const Flowambassador2 = (props) => {
  const [isVisible, setIsVisible] = useState(1)
  return (
    <div className="flowambassador2-thq-ambassadors-elm">
      {isVisible === 1 && (
        <div className="flowambassador2-container10 chapter">
          <section className="chapter_left flowambassador2-thq-left-elm">
            <div className="flowambassador2-container11">
              <div className="flowambassador2-container12">
                <span className="index_blue">{props.text2}</span>
                <div className="flowambassador2-thq-divider-elm1"></div>
                <span className="index_black">{props.text3}</span>
              </div>
              <h2 className="heading">{props.heading1}</h2>
            </div>
            <p className="paragraph">
              <span className="flowambassador2-text12">Contribute </span>
              <span>€</span>
              <span className="flowambassador2-text14">
                5,000 or more and you or someone you choose will become an
                Ambassador.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="flowambassador2-text15">J</span>
              <span className="flowambassador2-text16">oin</span>
              <span>
                {' '}
                the ranks of pioneers for driving positive change in Romania and
                be rewarded for your invaluable contribution with equally
                precious distinction.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt={props.imageAlt1}
                src={props.imageSrc2}
                className="chapter_img"
              />
            </div>
            <span
              onClick={() => setIsVisible(2)}
              className="flowambassador2-text18 formula_button"
            >
              {props.text}
            </span>
          </section>
          <div className="flowambassador2-thq-right-elm chapter_right">
            <div className="flowambassador2-thq-intro-elm">
              <span className="one-liner">{props.text1}</span>
              <p className="paragraph">{props.caption1}</p>
            </div>
            <div className="flowambassador2-thq-divider-elm2"></div>
          </div>
        </div>
      )}
      {isVisible === 2 && (
        <div className="flow_card">
          <div className="flowambassador2-thq-buttons-elm10">
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador2-container13">
            <div className="flowambassador2-thq-header-elm1">
              <div className="flowambassador2-container14">
                <div className="flowambassador2-container15">
                  <span className="index_black">{props.section2}</span>
                  <div className="flowambassador2-container16">
                    <span className="index_blue">{props.text11}</span>
                    <div className="flowambassador2-thq-divider-elm3"></div>
                    <span className="index_black">{props.text21}</span>
                  </div>
                </div>
                <label className="flowambassador2-thq-name-elm1 heading">
                  {props.name1}
                </label>
              </div>
              <p className="flowambassador2-thq-caption-elm3 paragraph">
                {props.caption21}
              </p>
            </div>
            <div className="flowambassador2-thq-buttons-elm11">
              <div
                onClick={() => setIsVisible(3)}
                className="flowambassador2-thq-button-elm11 flow_button"
              >
                <span className="flowambassador2-thq-text-elm10">
                  {props.text6}
                </span>
              </div>
              <div
                onClick={() => setIsVisible(8)}
                className="flowambassador2-thq-button-elm12 flow_button"
              >
                <span className="flowambassador2-thq-text-elm11">
                  {props.text17}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 3 && (
        <div className="flow_card">
          <div className="flowambassador2-thq-buttons-elm12">
            <div onClick={() => setIsVisible(2)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador2-container17">
            <div className="flowambassador2-thq-header-elm2">
              <div className="flowambassador2-container18">
                <span className="index_black">{props.section11}</span>
                <div className="flowambassador2-container19">
                  <span className="index_blue">{props.text4}</span>
                  <div className="flowambassador2-thq-divider-elm4"></div>
                  <span className="index_black">{props.text5}</span>
                </div>
              </div>
              <label className="flowambassador2-thq-name-elm2 heading">
                {props.name11}
              </label>
            </div>
            <div className="flowambassador2-container20">
              <div className="flowambassador2-container21">
                <div>
                  <div className="flowambassador2-container22">
                    <img
                      alt={props.imageAlt11}
                      src={props.imageSrc11}
                      className="flowambassador2-image11"
                    />
                    <span className="flow_text">{props.text31}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador2-container23">
                    <img
                      alt={props.imageAlt21}
                      src={props.imageSrc21}
                      className="flowambassador2-image12"
                    />
                    <span className="flow_text">{props.text41}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador2-container24">
                    <img
                      alt={props.imageAlt31}
                      src={props.imageSrc31}
                      className="flowambassador2-image13"
                    />
                    <span className="flow_text">{props.text51}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador2-container25">
                    <img
                      alt={props.imageAlt41}
                      src={props.imageSrc41}
                      className="flowambassador2-image14"
                    />
                    <div className="flowambassador2-container26">
                      <span className="flow_text">{props.text61}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flowambassador2-container27">
                    <img
                      alt={props.imageAlt51}
                      src={props.imageSrc51}
                      className="flowambassador2-image15"
                    />
                    <div className="flowambassador2-container28">
                      <span className="flow_text">{props.text71}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador2-thq-buttons-elm13">
              <div
                onClick={() => setIsVisible(4)}
                className="flowambassador2-thq-button-elm15 flow_button"
              >
                <span className="flowambassador2-thq-text-elm17">
                  {props.text25}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 4 && (
        <div className="flow_card">
          <div className="flowambassador2-thq-buttons-elm14">
            <div onClick={() => setIsVisible(3)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador2-container29">
            <div className="flowambassador2-thq-header-elm3">
              <div className="flowambassador2-container30">
                <div className="flowambassador2-container31">
                  <span className="index_black">{props.section21}</span>
                  <div className="flowambassador2-container32">
                    <span className="index_blue">{props.text13}</span>
                    <div className="flowambassador2-thq-divider-elm5"></div>
                    <span className="index_black">{props.text14}</span>
                  </div>
                </div>
                <label className="flowambassador2-thq-name-elm3 heading">
                  {props.name21}
                </label>
              </div>
            </div>
            <div className="flowambassador2-container33">
              <p className="flowambassador2-thq-caption-elm4 paragraph">
                <span>{props.text8}</span>
                <a href="#brand" className="flowambassador2-link1">
                  {props.text9}
                </a>
              </p>
              <p className="flowambassador2-thq-caption-elm5 paragraph">
                {props.caption21111}
              </p>
            </div>
            <div className="flowambassador2-thq-field-elm15">
              <div className="flowambassador2-container34">
                <img
                  alt={props.imageAlt61}
                  src={props.imageSrc61}
                  className="flowambassador2-image16 flow_image"
                />
                <span className="flow_text2">
                  <span>{props.text37}</span>
                  <span className="flowambassador2-text28">{props.text38}</span>
                  <span className="flowambassador2-text29">{props.text39}</span>
                </span>
              </div>
            </div>
            <div className="flowambassador2-thq-buttons-elm15">
              <p className="flowambassador2-thq-caption-elm6 paragraph">
                <span>{props.text10}</span>
                <a href="#strategy" className="flowambassador2-link2">
                  {props.text29}
                </a>
              </p>
              <div
                onClick={() => setIsVisible(5)}
                className="flowambassador2-thq-button-elm18 flow_button"
              >
                <span className="flowambassador2-thq-text-elm19">
                  {props.text81}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 5 && (
        <div className="flow_card">
          <div className="flowambassador2-thq-buttons-elm16">
            <div onClick={() => setIsVisible(4)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador2-container35">
            <div className="flowambassador2-thq-header-elm4">
              <div className="flowambassador2-container36">
                <span className="index_black">{props.section31}</span>
                <div className="flowambassador2-container37">
                  <span className="index_blue">{props.text15}</span>
                  <div className="flowambassador2-thq-divider-elm6"></div>
                  <span className="index_black">{props.text16}</span>
                </div>
              </div>
              <label className="flowambassador2-thq-name-elm4 heading">
                {props.name31}
              </label>
            </div>
            <div className="flowambassador2-thq-field-elm16">
              <div className="flowambassador2-container38">
                <img
                  alt={props.imageAlt71}
                  src={props.imageSrc71}
                  className="flowambassador2-image17 flow_image"
                />
                <div className="flowambassador2-container39">
                  <span className="flow_text2">{props.text101}</span>
                  <div className="flowambassador2-container40">
                    <img
                      alt={props.imageAlt81}
                      src={props.imageSrc81}
                      className="flowambassador2-image18"
                    />
                    <span className="flow_text">{props.text111}</span>
                  </div>
                  <div className="flowambassador2-container41">
                    <img
                      alt={props.imageAlt91}
                      src={props.imageSrc91}
                      className="flowambassador2-image19"
                    />
                    <span className="flow_text">{props.text122}</span>
                  </div>
                  <div className="flowambassador2-container42">
                    <img
                      alt={props.imageAlt912}
                      src={props.imageSrc912}
                      className="flowambassador2-image20"
                    />
                    <span className="flow_text">{props.text1211}</span>
                  </div>
                  <div className="flowambassador2-container43">
                    <img
                      alt={props.imageAlt9111}
                      src={props.imageSrc9111}
                      className="flowambassador2-image21"
                    />
                    <span className="flow_text">{props.text12111}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador2-thq-buttons-elm17">
              <div
                onClick={() => setIsVisible(6)}
                className="flowambassador2-thq-button-elm21 flow_button"
              >
                <span className="flowambassador2-thq-text-elm25">
                  {props.text91}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 6 && (
        <div className="flow_card">
          <div className="flowambassador2-thq-buttons-elm18">
            <div onClick={() => setIsVisible(5)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador2-container44">
            <div className="flowambassador2-thq-header-elm5">
              <div className="flowambassador2-container45">
                <span className="index_black">{props.section51}</span>
                <div className="flowambassador2-container46">
                  <span className="index_blue">{props.text19}</span>
                  <div className="flowambassador2-thq-divider-elm7"></div>
                  <span className="index_black">{props.text20}</span>
                </div>
              </div>
              <label className="flowambassador2-thq-name-elm5 heading">
                {props.name51}
              </label>
            </div>
            <div className="flowambassador2-thq-field-elm17">
              <div className="flowambassador2-container47">
                <img
                  alt={props.imageAlt131}
                  src={props.imageSrc131}
                  className="flowambassador2-image22 flow_image"
                />
                <div className="flowambassador2-container48">
                  <span className="flow_text2">{props.text181}</span>
                  <div className="flowambassador2-container49">
                    <img
                      alt={props.imageAlt141}
                      src={props.imageSrc141}
                      className="flowambassador2-image23"
                    />
                    <span className="flow_text">{props.text191}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador2-thq-buttons-elm19">
              <div
                onClick={() => setIsVisible(7)}
                className="flowambassador2-thq-button-elm24 flow_button"
              >
                <span className="flowambassador2-thq-text-elm28">
                  {props.text171}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 7 && (
        <div className="flow_card">
          <div className="flowambassador2-thq-buttons-elm20">
            <div onClick={() => setIsVisible(6)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador2-container50">
            <div className="flowambassador2-thq-header-elm6">
              <div className="flowambassador2-container51">
                <span className="index_black">{props.section61}</span>
                <div className="flowambassador2-container52">
                  <span className="index_blue">{props.text211}</span>
                  <div className="flowambassador2-thq-divider-elm8"></div>
                  <span className="index_black">{props.text22}</span>
                </div>
              </div>
              <label className="flowambassador2-thq-name-elm6 heading">
                {props.name61}
              </label>
            </div>
            <div className="flowambassador2-thq-field-elm18">
              <div className="flowambassador2-container53">
                <img
                  alt={props.imageAlt151}
                  src={props.imageSrc151}
                  className="flowambassador2-image24 flow_image"
                />
                <div className="flowambassador2-container54">
                  <span className="flow_text2">{props.text212}</span>
                  <div className="flowambassador2-container55">
                    <img
                      alt={props.imageAlt161}
                      src={props.imageSrc161}
                      className="flowambassador2-image25"
                    />
                    <span className="flow_text">{props.text221}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador2-thq-buttons-elm21">
              <div
                onClick={() => setIsVisible(8)}
                className="flowambassador2-thq-button-elm27 flow_button"
              >
                <span className="flowambassador2-thq-text-elm31">
                  {props.text201}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 8 && (
        <div className="flow_card">
          <div className="flowambassador2-thq-buttons-elm22">
            <div onClick={() => setIsVisible(7)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador2-container56">
            <div className="flowambassador2-thq-header-elm7">
              <div className="flowambassador2-container57">
                <span className="index_black">{props.section71}</span>
                <div className="flowambassador2-container58">
                  <span className="index_blue">{props.text23}</span>
                  <div className="flowambassador2-thq-divider-elm9"></div>
                  <span className="index_black">{props.text24}</span>
                </div>
              </div>
              <label className="flowambassador2-thq-name-elm7 heading">
                {props.name71}
              </label>
            </div>
            <div className="flowambassador2-container59">
              <a
                href="https://www.instagram.com/romania/"
                target="_blank"
                rel="noreferrer noopener"
                className="flowambassador2-link3"
              >
                <div className="flowambassador2-thq-field-elm19 ambassador_contact">
                  <div className="flowambassador2-container60">
                    <img
                      alt={props.imageAlt1031}
                      src={props.imageSrc1131}
                      className="flowambassador2-image26"
                    />
                    <div className="flowambassador2-container61">
                      <span className="flowambassador2-thq-text-elm32 flow_text">
                        {props.text22121}
                      </span>
                      <span className="flowambassador2-thq-text-elm33 flow_text">
                        {props.text22133221}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt1121}
                    src={props.imageSrc1221}
                    className="flowambassador2-image27"
                  />
                  <img
                    alt={props.imageAlt1261}
                    src={props.imageSrc1761}
                    className="flowambassador2-image28"
                  />
                  <img
                    alt={props.imageAlt12241}
                    src={props.imageSrc17241}
                    className="flowambassador2-image29"
                  />
                  <img
                    alt={props.imageAlt12141}
                    src={props.imageSrc17141}
                    className="flowambassador2-image30"
                  />
                  <img
                    alt={props.imageAlt1741}
                    src={props.imageSrc1841}
                    className="flowambassador2-image31"
                  />
                </div>
              </a>
              <a
                href="mailto:hi@romania.org.ro?subject=Hi @Romania!"
                className="flowambassador2-link4"
              >
                <div className="flowambassador2-thq-field-elm20 ambassador_contact">
                  <div className="flowambassador2-container62">
                    <img
                      alt={props.imageAlt10231}
                      src={props.imageSrc11231}
                      className="flowambassador2-image32"
                    />
                    <div className="flowambassador2-container63">
                      <span className="flowambassador2-thq-text-elm34 flow_text">
                        {props.text2213231}
                      </span>
                      <span className="flowambassador2-thq-text-elm35 flow_text">
                        {props.text2213341}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt122121}
                    src={props.imageSrc172121}
                    className="flowambassador2-image33"
                  />
                  <img
                    alt={props.imageAlt12321}
                    src={props.imageSrc1732}
                    className="flowambassador2-image34"
                  />
                  <img
                    alt={props.imageAlt121121}
                    src={props.imageSrc171121}
                    className="flowambassador2-image35"
                  />
                  <img
                    alt={props.imageAlt17121}
                    src={props.imageSrc18121}
                    className="flowambassador2-image36"
                  />
                </div>
              </a>
              <a href="tel:+40750453880" className="flowambassador2-link5">
                <div className="flowambassador2-thq-field-elm21 ambassador_contact">
                  <div className="flowambassador2-container64">
                    <img
                      alt={props.imageAlt102221}
                      src={props.imageSrc112221}
                      className="flowambassador2-image37"
                    />
                    <div className="flowambassador2-container65">
                      <span className="flowambassador2-thq-text-elm36 flow_text">
                        {props.text22132121}
                      </span>
                      <span className="flowambassador2-thq-text-elm37 flow_text">
                        {props.text22133121}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt1111221}
                    src={props.imageSrc1211221}
                    className="flowambassador2-image38"
                  />
                  <img
                    alt={props.imageAlt122221}
                    src={props.imageSrc172221}
                    className="flowambassador2-image39"
                  />
                  <img
                    alt={props.imageAlt12421}
                    src={props.imageSrc17421}
                    className="flowambassador2-image40"
                  />
                  <img
                    alt={props.imageAlt121221}
                    src={props.imageSrc171221}
                    className="flowambassador2-image41"
                  />
                  <img
                    alt={props.imageAlt17221}
                    src={props.imageSrc18221}
                    className="flowambassador2-image42"
                  />
                </div>
              </a>
            </div>
            <div className="flowambassador2-thq-buttons-elm23">
              <div
                onClick={() => setIsVisible(1)}
                className="flowambassador2-thq-button-elm30 flow_button"
              >
                <span className="flowambassador2-thq-text-elm38">
                  {props.text231}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Flowambassador2.defaultProps = {
  text22: '07',
  imageSrc18221: '/frames/corner_arrow.svg',
  imageAlt912: 'image',
  text61: 'Bespoke medal crafted by the State Mint',
  imageAlt122121: 'image',
  text171: 'Continue ->',
  text3: '08',
  imageAlt141: 'image',
  imageSrc17141: '/frames/corner.svg',
  imageSrc81: '/frames/frame_shape2.svg',
  imageAlt1261: 'image',
  text1: 'Being an Ambassador has its perks.',
  text22133121: 'call us',
  section31: 'Ambassadors Program',
  imageAlt41: 'image',
  imageSrc61: '/external/roi_blue.svg',
  text10: 'See how your financial contribution creates value for Romania, ',
  imageAlt12421: 'image',
  text13: '03',
  text2213341: 'send us an email',
  imageAlt10231: 'image',
  imageAlt121121: 'image',
  imageSrc171221: '/frames/corner.svg',
  imageSrc912: '/frames/frame_shape2.svg',
  imageSrc141: '/frames/frame_shape2.svg',
  imageSrc11231: '/assets/ig_blue%20copy%202-200h.png',
  text20: '07',
  name31: 'Decide who becomes an Ambassador',
  name11: 'What you get',
  imageAlt12241: 'image',
  section21: 'Ambassadors Program',
  imageSrc1131: '/assets/ig_blue%20copy-200w.png',
  text21: '07',
  text2: 'Chapter 01',
  imageAlt121221: 'image',
  name61: 'Enjoy flexibility in how you contribute',
  text6: 'Continue',
  imageSrc21: '/formula/roi_blue2.svg',
  text22133221: 'text us on instagram',
  imageSrc161: '/frames/frame_shape2.svg',
  imageSrc1221: '/assets/asset%2030-200w.png',
  section2: 'Ambassadors Program',
  imageAlt122221: 'image',
  imageSrc171121: '/frames/corner.svg',
  imageSrc131: '/external/roi_blue.svg',
  text12111:
    'Donating for others means they become Ambassadors and they receive all the benefits associated.',
  imageAlt51: 'image',
  text39: ' to become an Ambassador or gift the title to others',
  text211: '06',
  imageSrc1761: '/frames/corner.svg',
  text181: 'Donate as a private person, company or non-profit',
  imageSrc17241: '/frames/corner.svg',
  text25: 'Continue ->',
  name21: 'Create positive change as an Ambassador',
  imageSrc31: '/formula/roi_blue2.svg',
  text5: '07',
  text2213231: 'hi@romania.org.ro',
  imageAlt11: 'image',
  text101:
    'Choose yourself, friends, family or colleagues or commemorate others by making them Ambassadors',
  text16: '07',
  text212: 'Donate via bank transfer or other preferred methods',
  name1: 'Ambassadors are the driving force for growth',
  section11: 'Ambassadors Program',
  section51: 'Ambassadors Program',
  imageSrc1732: '/frames/corner.svg',
  imageSrc41: '/formula/roi_blue2.svg',
  imageSrc91: '/frames/frame_shape2.svg',
  text8:
    'Our mission is to empower Romania via a Country Brand, Media Engine, Tourism and Tourism Promotion platforms and much more. Read all about it ',
  imageSrc71: '/external/roi_blue.svg',
  name71: 'Get in touch to start your Ambassador journey',
  text91: 'Continue ->',
  imageSrc151: '/external/roi_blue.svg',
  imageAlt161: 'image',
  imageSrc1211221: '/assets/asset%2028-200w.png',
  text41: 'Name  on the @Romania platform',
  text22121: '@romania',
  text231: 'Done',
  text29: 'here.',
  imageAlt17121: 'image',
  imageAlt1031: 'image',
  imageAlt1111221: 'image',
  text14: '07',
  imageSrc172221: '/frames/corner.svg',
  text4: '02',
  imageAlt151: 'image',
  imageSrc9111: '/frames/frame_shape2.svg',
  text31: 'Signed Certificate of Merit',
  section61: 'Ambassadors Program',
  caption21111:
    "As a non-profit, we are building value for Romania by lifting its tourism industry. Contributing to our initiative means you help boost our country's economy and you have a positive impact on Romania's tourism promotion.",
  text17: "I've decided ->",
  text9: 'here.',
  imageAlt1: 'image',
  text191:
    'When donating as a company or non-profit, please keep in mind that the title of Ambassador along with benefits can only be given to yourself or the people you choose and cannot be attributed to said company or non-profit.',
  text15: '04',
  imageAlt61: 'image',
  imageSrc112221: '/assets/ig_blue%20copy%203-200w.png',
  imageSrc172121: '/frames/corner.svg',
  imageAlt21: 'image',
  text51: 'Name on an important monument',
  text71: 'Elite networking opportunities and experiences',
  imageSrc1841: '/frames/corner_arrow.svg',
  imageAlt1121: 'image',
  name51: 'Enjoy flexibility in how you contribute',
  imageAlt1741: 'image',
  imageAlt131: 'image',
  imageSrc17421: '/frames/corner.svg',
  caption21:
    'We believe that helping build Romania’s Country Brand deserves to be recognized. Join the ranks of pioneers for driving positive change in Romania and be rewarded for your invaluable contribution with equally precious distinction.',
  text22132121: '+40 750 453 880',
  imageSrc2: '/nav patterns/ambassadors.svg',
  imageAlt91: 'image',
  section71: 'Ambassadors Program',
  text23: '07',
  caption1:
    "We believe that supporting Romania’s tourism promotion deserves to be recognized. Here's what you get as an Ambassador:",
  imageAlt102221: 'image',
  imageAlt81: 'image',
  imageSrc51: '/formula/roi_blue2.svg',
  text122:
    'You need to donate €5,000 or more for each person you wish to honor as an Ambassador.',
  imageSrc18121: '/frames/corner_arrow.svg',
  text11: '01',
  imageAlt12321: 'image',
  imageAlt17221: 'image',
  text38: '€5,000 or more',
  imageAlt12141: 'image',
  text24: '07',
  imageAlt9111: 'image',
  imageAlt31: 'image',
  text: 'I want to be an Ambassador',
  heading1: 'Ambassadors are the driving force for growth ',
  text37: 'Contribute\xA0',
  text201: 'Continue ->',
  text221:
    "We are happy to accommodate alternative donation methods according to your preference. Send us an email and we'll get it sorted.",
  text1211:
    'Donating for yourself means you become an Ambassador and you receive all the benefits associated.',
  imageSrc11: '/formula/roi_blue2.svg',
  imageAlt71: 'image',
  text111:
    'This is a way for you to honor the people around you or even celebrate the memory of someone dear to you, or someone who inspired you, with the title of Ambassador.',
  text81: 'Continue ->',
  text19: '05',
}

Flowambassador2.propTypes = {
  text22: PropTypes.string,
  imageSrc18221: PropTypes.string,
  imageAlt912: PropTypes.string,
  text61: PropTypes.string,
  imageAlt122121: PropTypes.string,
  text171: PropTypes.string,
  text3: PropTypes.string,
  imageAlt141: PropTypes.string,
  imageSrc17141: PropTypes.string,
  imageSrc81: PropTypes.string,
  imageAlt1261: PropTypes.string,
  text1: PropTypes.string,
  text22133121: PropTypes.string,
  section31: PropTypes.string,
  imageAlt41: PropTypes.string,
  imageSrc61: PropTypes.string,
  text10: PropTypes.string,
  imageAlt12421: PropTypes.string,
  text13: PropTypes.string,
  text2213341: PropTypes.string,
  imageAlt10231: PropTypes.string,
  imageAlt121121: PropTypes.string,
  imageSrc171221: PropTypes.string,
  imageSrc912: PropTypes.string,
  imageSrc141: PropTypes.string,
  imageSrc11231: PropTypes.string,
  text20: PropTypes.string,
  name31: PropTypes.string,
  name11: PropTypes.string,
  imageAlt12241: PropTypes.string,
  section21: PropTypes.string,
  imageSrc1131: PropTypes.string,
  text21: PropTypes.string,
  text2: PropTypes.string,
  imageAlt121221: PropTypes.string,
  name61: PropTypes.string,
  text6: PropTypes.string,
  imageSrc21: PropTypes.string,
  text22133221: PropTypes.string,
  imageSrc161: PropTypes.string,
  imageSrc1221: PropTypes.string,
  section2: PropTypes.string,
  imageAlt122221: PropTypes.string,
  imageSrc171121: PropTypes.string,
  imageSrc131: PropTypes.string,
  text12111: PropTypes.string,
  imageAlt51: PropTypes.string,
  text39: PropTypes.string,
  text211: PropTypes.string,
  imageSrc1761: PropTypes.string,
  text181: PropTypes.string,
  imageSrc17241: PropTypes.string,
  text25: PropTypes.string,
  name21: PropTypes.string,
  imageSrc31: PropTypes.string,
  text5: PropTypes.string,
  text2213231: PropTypes.string,
  imageAlt11: PropTypes.string,
  text101: PropTypes.string,
  text16: PropTypes.string,
  text212: PropTypes.string,
  name1: PropTypes.string,
  section11: PropTypes.string,
  section51: PropTypes.string,
  imageSrc1732: PropTypes.string,
  imageSrc41: PropTypes.string,
  imageSrc91: PropTypes.string,
  text8: PropTypes.string,
  imageSrc71: PropTypes.string,
  name71: PropTypes.string,
  text91: PropTypes.string,
  imageSrc151: PropTypes.string,
  imageAlt161: PropTypes.string,
  imageSrc1211221: PropTypes.string,
  text41: PropTypes.string,
  text22121: PropTypes.string,
  text231: PropTypes.string,
  text29: PropTypes.string,
  imageAlt17121: PropTypes.string,
  imageAlt1031: PropTypes.string,
  imageAlt1111221: PropTypes.string,
  text14: PropTypes.string,
  imageSrc172221: PropTypes.string,
  text4: PropTypes.string,
  imageAlt151: PropTypes.string,
  imageSrc9111: PropTypes.string,
  text31: PropTypes.string,
  section61: PropTypes.string,
  caption21111: PropTypes.string,
  text17: PropTypes.string,
  text9: PropTypes.string,
  imageAlt1: PropTypes.string,
  text191: PropTypes.string,
  text15: PropTypes.string,
  imageAlt61: PropTypes.string,
  imageSrc112221: PropTypes.string,
  imageSrc172121: PropTypes.string,
  imageAlt21: PropTypes.string,
  text51: PropTypes.string,
  text71: PropTypes.string,
  imageSrc1841: PropTypes.string,
  imageAlt1121: PropTypes.string,
  name51: PropTypes.string,
  imageAlt1741: PropTypes.string,
  imageAlt131: PropTypes.string,
  imageSrc17421: PropTypes.string,
  caption21: PropTypes.string,
  text22132121: PropTypes.string,
  imageSrc2: PropTypes.string,
  imageAlt91: PropTypes.string,
  section71: PropTypes.string,
  text23: PropTypes.string,
  caption1: PropTypes.string,
  imageAlt102221: PropTypes.string,
  imageAlt81: PropTypes.string,
  imageSrc51: PropTypes.string,
  text122: PropTypes.string,
  imageSrc18121: PropTypes.string,
  text11: PropTypes.string,
  imageAlt12321: PropTypes.string,
  imageAlt17221: PropTypes.string,
  text38: PropTypes.string,
  imageAlt12141: PropTypes.string,
  text24: PropTypes.string,
  imageAlt9111: PropTypes.string,
  imageAlt31: PropTypes.string,
  text: PropTypes.string,
  heading1: PropTypes.string,
  text37: PropTypes.string,
  text201: PropTypes.string,
  text221: PropTypes.string,
  text1211: PropTypes.string,
  imageSrc11: PropTypes.string,
  imageAlt71: PropTypes.string,
  text111: PropTypes.string,
  text81: PropTypes.string,
  text19: PropTypes.string,
}

export default Flowambassador2
